export const Separator = () => <div className="h-4 w-px bg-white/50" />;
